export const NAMESPACE = 'analytics-test-summary';

export const SELECT_BY_VERSION = `${NAMESPACE}/SELECT_BY_VERSION`;
export const CLEAR_SELECT_BY_VERSION = `${NAMESPACE}/CLEAR_SELECT_BY_VERSION`;
export const CLEANUP_TEST_SUMMARY = `${NAMESPACE}/CLEANUP_TEST_SUMMARY`;
